import './style.scss';

import { Loader, Title } from '@gjensidige/builders-components';

import { SectionLoaderProps } from './Types';

export const SectionLoader: React.FC<SectionLoaderProps> = ({
  showLoader = false,
  spinnerEnabled = true,
  spinnerSize = 'lg',
  spinnerText
}: SectionLoaderProps) => {
  return (
    <>
      {showLoader && (
        <>
          <div className="page-cover"></div>
          {spinnerEnabled && (
            <div className="section-loader-wrapper">
              <Loader className="spinner-element" size={spinnerSize} />
              <Title as="h2" size="5" className="spinner-text">
                {spinnerText}
              </Title>
            </div>
          )}
        </>
      )}
    </>
  );
};
